import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Upload = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Upload({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M4.75 11.5V4.75H19.25V11.5C19.25 11.7761 19.4739 12 19.75 12H20.25C20.5261 12 20.75 11.7761 20.75 11.5V4.5C20.75 3.80964 20.1904 3.25 19.5 3.25H4.5C3.80964 3.25 3.25 3.80964 3.25 4.5V11.5C3.25 11.7761 3.47386 12 3.75 12H4.25C4.52614 12 4.75 11.7761 4.75 11.5ZM11.1162 8.82321C11.6043 8.33505 12.3958 8.33505 12.8839 8.82321L17.1768 13.1161C17.3721 13.3114 17.3721 13.6279 17.1768 13.8232L16.8233 14.1768C16.628 14.372 16.3114 14.372 16.1162 14.1768L12.75 10.8106V20.5C12.75 20.7761 12.5261 21 12.25 21H11.75C11.4739 21 11.25 20.7761 11.25 20.5V10.8107L7.88394 14.1768C7.68868 14.372 7.3721 14.372 7.17683 14.1768L6.82328 13.8232C6.62802 13.6279 6.62802 13.3114 6.82328 13.1161L11.1162 8.82321Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'upload-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Upload;
